<template>
  <ElPopover
    class="matching-type-help"
    placement="bottom"
    width="700"
    trigger="hover"
  >
    <div class="row">
      <MatchingTypeHelpColumn
        class="columns"
        :title="$t('ADVERTISEMENT.BID.EXACT_MATCHING_TYPE')"
        :keywords="$t('ADVERTISEMENT.BID.MATCH_TYPE_EXACT_EXAMPLES')"
      >
        {{ $t('ADVERTISEMENT.BID.MATCH_TYPE_EXACT_DESCRIPTION') }}
      </MatchingTypeHelpColumn>
      <MatchingTypeHelpColumn
        class="columns"
        :title="$t('ADVERTISEMENT.BID.KEYWORD_MATCHING_TYPE')"
        :keywords="$t('ADVERTISEMENT.BID.MATCH_TYPE_KEYWORD_EXAMPLES')"
      >
        {{ $t('ADVERTISEMENT.BID.MATCH_TYPE_KEYWORD_DESCRIPTION') }}
      </MatchingTypeHelpColumn>
      <MatchingTypeHelpColumn
        class="columns"
        :title="$t('ADVERTISEMENT.BID.BROAD_MATCHING_TYPE')"
        :keywords="$t('ADVERTISEMENT.BID.MATCH_TYPE_BROAD_EXAMPLES')"
      >
        {{ $t('ADVERTISEMENT.BID.MATCH_TYPE_BROAD_DESCRIPTION') }}
      </MatchingTypeHelpColumn>
    </div>
    <div slot="reference" class="matching-type-help__handler">
      {{ $t('ADVERTISEMENT.BID.MATCH_TYPE_DESCRIPTION_TITLE') }}
      <i class="el-icon-info" />
    </div>
  </ElPopover>
</template>

<script>
import MatchingTypeHelpColumn from './MatchingTypeHelpColumn';
export default {
  name: 'MatchingTypeHelp',
  components: {
    MatchingTypeHelpColumn,
  },
};
</script>

<style lang="scss">
.matching-type-help {
  &__handler {
    user-select: none;
    cursor: pointer;
  }
}
</style>
